<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 10px auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>子账号</h4>
          <div>
            <el-button type="primary" class="adduser" @click="handleReturn">返回</el-button>
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="username" align="center" label="账号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nick" align="center" label="昵称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="roleName" align="center" label="角色" show-overflow-tooltip></el-table-column>
            <el-table-column prop="departName" align="center" label="组织机构" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realName" align="center" label="姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mobile" align="center" label="手机号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qq" align="center" label="QQ" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" align="center" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">
                  <span class="show-line show-rline"></span>
                  冻结
                </div>
                <div v-if="scope.row.status == 1">
                  <span class="show-line show-bline"></span>
                  启用
                </div>
              </template>
            </el-table-column>
            <el-table-column style="border: 0" fixed="right" align="center" label="操作" width="250">
              <template style="border: 0" slot-scope="scope">
                <el-button @click="handleStatus(scope.row)" type="text" size="small"
                  v-if="scope.row.status == 1">冻结</el-button>
                <el-button @click="handleStatus(scope.row)" type="text" size="small"
                  v-if="scope.row.status == 0">启用</el-button>
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="pagination-container">
      <div class="page"></div>
      <div class="pagination-content-container">
        <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange"
          :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="800px" center
      style="z-index: 10000">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12" style="dispaly: flex">
            <el-form-item label="账号：" prop="username">
              <el-input v-model="ruleForm.username" placeholder="请输入账号" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码：" prop="password">
              <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" maxlength="50"
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="组织机构：" prop="departId">
              <el-cascader @change="departChange" :show-all-levels="false" v-model="ruleForm.departId"
                :options="departArray" :props="optionProps" clearable placeholder="请选择组织结构"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色：" prop="roleId">
              <el-select v-model="ruleForm.roleId" placeholder="请选择角色" clearable>
                <el-option v-for="item in roleArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="昵称：" prop="nick">
              <el-input v-model="ruleForm.nick" placeholder="请输入昵称" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：" prop="realName">
              <el-input v-model="ruleForm.realName" placeholder="请输入姓名" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别：" prop="gender">
              <el-select v-model="ruleForm.gender" placeholder="请选择性别" clearable>
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input v-model="ruleForm.mobile" placeholder="请输入手机号" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱：" prop="email">
              <el-input v-model="ruleForm.email" placeholder="请输入邮箱" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ：" prop="qq">
              <el-input v-model="ruleForm.qq" placeholder="请输入QQ" maxlength="50" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        parentId: this.$route.query.parentId,
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: "",
        parentId: "",
        username: "",
        password: "",
        departId: "",
        roleId: "",
        nick: "",
        realName: "",
        gender: "",
        mobile: "",
        email: "",
        qq: "",
      },
      rules: {
        // 添加、编辑弹窗表单规则
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        departId: [
          {
            required: true,
            message: "请选择组织机构",
            trigger: "change",
          },
        ],
        roleId: [
          {
            required: true,
            message: "请选择角色",
            trigger: "change",
          },
        ],
        nick: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur",
          },
        ],
        realName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: false,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        qq: [
          {
            required: false,
            message: "请输入QQ",
            trigger: "blur",
          },
        ],
      },
      addEditTitle: "添加子账号", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      departArray: [], // 组织机构数组
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
        multiple: false,
      },
      roleArray: [], // 角色数组
      oldPassword: "", // 旧密码
    };
  },
  created() {
    // 查询
    this.getList();

    // 获取组织机构列表
    this.getDepartList();

    // 获取角色列表
    this.getSysRoleList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        parentId: this.$route.query.parentId,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.system.getSysUserList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
        }
      });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system.delSysUser(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑子账号";
      this.ruleForm.id = row.id;

      // 获取详情
      this.$api.system.getSysUser({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.gender =
            res.data.gender != undefined ? res.data.gender.toString() : "";
          this.ruleForm = res.data;
          this.oldPassword = res.data.password;
        }
      });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加子账号";
      this.ruleForm.id = "";
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.password != this.oldPassword) {
            this.ruleForm.password = this.$utils.calcuMD5(
              this.ruleForm.password
            );
          }
          this.ruleForm.parentId = this.$route.query.parentId;
          this.$api.system.saveSysUser(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.handleCancel();
              this.handleSearch();
            }
          });
        }
      });
    },
    // 启用、禁用
    handleStatus(row) {
      this.$api.system.openOrCloseSysUser({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.handleSearch();
        }
      });
    },
    // 组织机构下拉切换
    departChange(val) {
      if (val && val.length > 0) {
        this.ruleForm.departId = val[val.length - 1];
        return;
      } else {
        this.ruleForm.departId = "";
      }
    },
    // 获取组织机构列表
    getDepartList() {
      this.$api.system.getDepartList(0).then((res) => {
        if (res.code == 200) {
          this.departArray = res.data;
        }
      });
    },
    // 获取上级组织机构id
    getParentDepartId(departId) {
      let parentDepartId = 0;
      this.departArray.every(function (val) {
        if (val.children) {
          let isEnd = false;
          val.children.every(function (val2) {
            if (val2.id == departId) {
              parentDepartId = val2.parentId;
              isEnd = true;
            }

            return val2.id != departId;
          });

          return !isEnd;
        }
      });

      return parentDepartId;
    },
    // 获取系统角色列表
    getSysRoleList() {
      this.$api.system.getAllSysRole().then((res) => {
        if (res.code == 200) {
          this.roleArray = res.data;
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `userManagement`,
        query: { currentShow: "second" },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>